module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ga-Hc-Ic-Jb.9686916d.png";